import React, { Component } from 'react';

import { withStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import CrudForUserDipendenti from './crud/Dipendenti/CrudForUserDipendenti'
import { modelProps } from '../../../model/Dipendenti';

import { styles } from '../../css/commonstyles'





class Dipendenti extends Component {

    constructor(props) {
        super(props);

    }



    render() {

        const { classes } = this.props;

        return (
            <div className={classes.backgroundStylefafafa} >
                <div className={classes.spacingStyle3} >
                    <CrudForUserDipendenti
                        modelName="Dipendenti"
                        modelNameSingolare="Dipendenti"
                        modelProps={modelProps}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {

    }

}

const mapDispatchToProps = (dispatch) => {

    return {


    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Dipendenti));